import { View } from "@tarojs/components";
import * as React from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { prefixClassname } from "../styles/index.js";
const IndexListSidebar = forwardRef((props, ref) => {
    const { inner, children, onClick, onTouchStart, onTouchMove, onTouchCancel, onTouchEnd } = props;
    return (React.createElement(View, { ref: ref, catchMove: true, className: classNames(prefixClassname("index-list__sidebar"), {
            inner: inner,
        }), children: children, onClick: onClick, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchCancel: onTouchCancel, onTouchEnd: onTouchEnd }));
});
export default IndexListSidebar;
